module.exports = __webpack_public_path__ + "img/kevin.ea3998e6.png";